var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-house"
  }, /*#__PURE__*/React.createElement("path", {
    id: "symbol",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2929 3.29289C11.6834 2.90237 12.3166 2.90237 12.7071 3.29289L20.7071 11.2929C20.9931 11.5789 21.0787 12.009 20.9239 12.3827C20.7691 12.7564 20.4045 13 20 13H19V20C19 20.5523 18.5523 21 18 21H6.00003C5.44774 21 5.00003 20.5523 5.00003 20V13H4.00003C3.59557 13 3.23093 12.7564 3.07615 12.3827C2.92137 12.009 3.00692 11.5789 3.29292 11.2929L11.2929 3.29289ZM6.35094 11.0633C6.73013 11.2054 7.00003 11.5712 7.00003 12V19H11V15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15V19H17V12C17 11.5712 17.2699 11.2054 17.6491 11.0633L12 5.41421L6.35094 11.0633Z",
    fill: "#005EC2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3b7b9c607854612f38fc2e17ecf82067.svg";
export { ForwardRef as ReactComponent };